"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const react_1 = require("react");
const lodash_1 = require("lodash");
const theme_1 = require("@zapier/theme");
const design_system_1 = require("@zapier/design-system");
const utils_1 = require("./utils");
const RuleGroupHeader_1 = __importDefault(require("./RuleGroupHeader"));
const RuleGroupActions_1 = __importDefault(require("./RuleGroupActions"));
const FieldRuleEditor_1 = __importDefault(require("./FieldRuleEditor"));
const ruleGroupContainer = core_1.css `
  padding-bottom: ${theme_1.Spacing.medium}px;
  border-bottom: 1px solid ${design_system_1.Colors.grey200};
  margin-bottom: ${theme_1.Spacing.medium}px;
  /* The last rule group doesn't have a separator or spacing */
  &:last-of-type {
    padding-bottom: 0;
    border-bottom: none;
    margin-bottom: 0;
  }
`;
const ruleEditorContainer = core_1.css `
  margin-bottom: ${theme_1.Spacing.small}px;
`;
function FilterField(props) {
    const { value = [], choiceGroups } = props;
    const criteria = utils_1.ensureMinimumRuleSet(value);
    const orGroups = utils_1.groupRules(criteria);
    const onChange = (newCriteria) => {
        props.onChange(newCriteria, { commit: true });
    };
    const onAddRule = (group) => {
        onChange(utils_1.addRule(criteria, utils_1.createEmptyRule(group)));
    };
    const onAddGroup = () => {
        onChange(utils_1.addRule(criteria, utils_1.createEmptyRule()));
    };
    const onRemoveRule = (ruleId) => {
        onChange(utils_1.removeRule(criteria, ruleId));
    };
    const onChangeRule = (rule) => {
        onChange(utils_1.updateRule(criteria, rule));
    };
    return (core_1.jsx(react_1.Fragment, null, lodash_1.map(orGroups, ({ group, rules }, index) => (core_1.jsx("div", { css: ruleGroupContainer, key: group },
        core_1.jsx(RuleGroupHeader_1.default, { isFirst: index === 0 }),
        lodash_1.map(rules, rule => (core_1.jsx("div", { css: ruleEditorContainer, key: rule.id },
            core_1.jsx(FieldRuleEditor_1.default, { choiceGroups: choiceGroups, onChange: onChangeRule, onRemove: onRemoveRule, rule: rule })))),
        core_1.jsx(RuleGroupActions_1.default, { canAddGroup: index === orGroups.length - 1, group: group, onAddGroup: onAddGroup, onAddRule: onAddRule }))))));
}
exports.default = FilterField;
